module.exports = __webpack_public_path__ + "static/media/Ambience.34475f81.wav";